import React from 'react';
import { MuiMarkdown } from '@lsoft/mui';

import DE from '../src/markdown/gtc_customer_card.de.md';
import EN from '../src/markdown/gtc_customer_card.en.md';
import FR from '../src/markdown/gtc_customer_card.fr.md';

import { ShopPage } from '../src/app/ShopPage';
import { getTranslation } from '@lsoft/translate';
import { shopServerSideProps } from '../src/tools/withShopPropsContext';

const GtcCustomerCard = (pageProps) => {
	return (
		<ShopPage {...pageProps} noLogin variant={'sidebarMenu'}>
			<MuiMarkdown tr={{ DE, EN, FR }} />
		</ShopPage>
	);
};

export const getServerSideProps = shopServerSideProps(async ({ locale }) => {
	return {
		props: {
			pageInfo: {
				title: getTranslation(
					{
						DE: 'Geschäftsbedingungen für die LToys Kundenkarte ',
						EN: 'Terms and Conditions for the LToys Customer Card ',
						// prettier-ignore
						FR: 'Conditions d\'utilisation de la carte client LToys ',
					},
					locale
				),
			},
		},
	};
});
export default GtcCustomerCard;
